import { FC } from 'react';
import { TbPointFilled } from 'react-icons/tb';

import { Box, Tooltip } from '@mantine/core';

import { Project, ProjectTeaser } from 'models';

import { useProjectMeta } from 'components/project-overview/hooks';
import { useCurrentUser } from 'hooks/use-current-user';

export const ProjectTeaserUpdateDot: FC<{
    project: Project | ProjectTeaser;
    lastView?: string | null;
}> = ({ project, lastView }) => {
    const user = useCurrentUser();
    const { updatedById } = useProjectMeta(project);

    const hasUnseenUpdate =
        // last update was not by current user
        updatedById !== user?.id &&
        // last update is after last view
        project.updatedAt &&
        lastView &&
        new Date(project.updatedAt) > new Date(lastView);

    if (!hasUnseenUpdate) {
        return null;
    }

    return (
        <Tooltip label="Updated since your last visit" position="top" withArrow withinPortal>
            <Box component="span" style={{ display: 'inline-flex', verticalAlign: 'middle' }}>
                <TbPointFilled size={14} style={{ color: 'var(--mantine-color-red-filled)' }} />
            </Box>
        </Tooltip>
    );
};
